import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Pedidos from "./pages/Pedidos";
import ConectarWhatsApp from "./pages/ConectarWhatsApp";
import Cardapio from "./pages/Cardapio";
import Produtos from "./pages/Produtos"; // 👈 novo módulo
import ContactsPage from "./pages/ContactsPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Header from "./components/Header";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Chat from "./pages/Chat";
import Dashboard from "./pages/dashboard";
import StatusPage from "./pages/StatusPage";
import SelfCheckout from "./pages/SelfCheckout";
import PedidoEfetuado from "./pages/PedidoEfetuado";

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));

  // 🔄 Atualiza automaticamente se o token mudar no localStorage
  useEffect(() => {
    const listener = () => setToken(localStorage.getItem("token"));
    window.addEventListener("storage", listener);
    return () => window.removeEventListener("storage", listener);
  }, []);

  // 🔐 Função usada pelo Login/Register
  const handleLoginSuccess = () => {
    setToken(localStorage.getItem("token"));
  };

  // 🚪 Caso o usuário não esteja logado
  if (!token) {
    return (
      <Router>
        <Switch>
          <Route exact path="/login">
            <Login onLoginSuccess={handleLoginSuccess} />
          </Route>
          <Route exact path="/register">
            <Register onRegisterSuccess={handleLoginSuccess} />
          </Route>
          <Route exact path="/selfcheckout">
            <SelfCheckout />
          </Route>
          <Route exact path="/pedidoefetuado">
            <PedidoEfetuado />
          </Route>
          <Redirect to="/login" />
        </Switch>

        {/* 🔔 Toaster global */}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </Router>
    );
  }

  // ✅ Caso esteja logado
  return (
    <Router>
      {/* Só oculta o Header nas rotas de login e register */}
      {window.location.pathname !== "/login" && window.location.pathname !== "/register" && <Header />}
      <Switch>
        <Route exact path="/pedidos" component={Pedidos} />
        <Route exact path="/whatsapp" component={ConectarWhatsApp} />
        <Route exact path="/cardapio" component={Cardapio} />
        <Route exact path="/produtos" component={Produtos} /> {/* 👈 novo */}
        <Route exact path="/chat" component={Chat} />
        <Route path="/dashboard" component={Dashboard} />
        <Route exact path="/contacts" component={ContactsPage} />
        <Route exact path="/status" component={StatusPage} />
        <Route exact path="/selfcheckout" component={SelfCheckout} />
        <Route exact path="/pedidoefetuado" component={PedidoEfetuado} />
        <Redirect to="/chat" />
      </Switch>

      {/* 🔔 Toaster global */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </Router>
  );
}

export default App;
